import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {environment} from 'src/environments/environment';
import {EffectsModule} from '@ngrx/effects';
import {FeatureAuthModule} from '~feature/feature-auth/feature-auth.module';
import {EntityRotaModule} from '~entity/entity-rota/entity-rota.module';
import {FeatureResumoModule} from '~feature/feature-resumo/feature-resumo.module';
import {FeatureMapModule} from '~feature/feature-map/feature-map.module';
import { EntityDocumentoModule } from '~entity/entity-documento/entity-documento.module';
import { EntityGrupoUsuarioModule } from '~entity/entity-grupo-usuario/entity-grupo-usuario.module';
import {EntityIndicadorModule} from '~entity/entity-indicador/entity-indicador.module';
import {EntityCardModule} from '~entity/entity-card/entity-card.module';
import {FeatureFiltroModule} from '~feature/feature-filtro/feature-filtro.module';
import {EntityUpdateModule} from '~entity/entity-update/entity-update.module';
import {EntityConfiguracaoModule} from '~entity/entity-configuracao/entity-configuracao.module';
import {FeatureAppModule} from '~feature/feature-app/feature-app.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forRoot({}, {}),
    StoreDevtoolsModule.instrument({maxAge: 25, logOnly: environment.production}),
    EffectsModule.forRoot([]),
    FeatureAuthModule,
    FeatureMapModule,
    FeatureAppModule,
    FeatureResumoModule,
    FeatureFiltroModule,
    EntityRotaModule,
    EntityUpdateModule,
    EntityDocumentoModule,
    EntityGrupoUsuarioModule,
    EntityIndicadorModule,
    EntityConfiguracaoModule,
    EntityCardModule,
  ],
})
export class AppStoreModule {
}
